import React from 'react'
import ReactTooltip, { TooltipProps } from 'react-tooltip'
import styled from 'styled-components'

import { withTypographySmall } from '@components/Typography'
import { r } from '@utils/styles/functions'

export interface ITooltip extends TooltipProps {
  elementId: string
  position?: 'top' | 'right' | 'bottom' | 'left'
}

//! important используется для переопределения дефолтных стилей
const StyledReactTooltip = styled(ReactTooltip)`
  padding: ${r(16)};
  color: ${(props) => props.theme.colors.graphite} !important;
  background-color: ${(props) => props.theme.colors.white} !important;
  box-shadow: ${(props) => props.theme.general.tooltipShadow} !important;
  opacity: 1 !important;
  border-radius: ${(props) => props.theme.general.borderRadius};
  ${withTypographySmall};
  pointer-events: auto !important;
  z-index: 999;
  &:hover {
    visibility: visible;
    opacity: 1;
  }
`

const Tooltip: React.FC<ITooltip> = (props) => {
  const { children, elementId, position = 'top', className, ...rest } = props

  return (
    <StyledReactTooltip
      className={className}
      id={elementId}
      effect="solid"
      place={position}
      border
      borderColor="#E2E6EC"
      arrowColor="white"
      overridePosition={({ left, top }, currentEvent, currentTarget, node) => {
        const d = document.documentElement
        if (node) {
          left = Math.min(d.clientWidth - node.clientWidth, left)
          top = Math.min(d.clientHeight - node.clientHeight, top)
          left = Math.max(0, left)
          top = Math.max(0, top)
        }
        return { top, left }
      }}
      {...rest}
    >
      {children}
    </StyledReactTooltip>
  )
}

export default Tooltip
